import React from "react";
import Placeholder from "react-bootstrap/Placeholder";
function Name(props) {
  const { name, loading } = props;
  return (
    <div className="object-list-item-name">
      {loading && (
        <Placeholder animation="glow">
          <Placeholder xs={6} size="lg" />
        </Placeholder>
      )}
      {!loading && name && name}
    </div>
  );
}

export default Name;
